import { TEAM_ILLUSTRATION_URL } from '../../../../../../constants/DigitalLibraryConstants';

import EmptyState from '../../../../../../components/EmptyState';
import SpotIllustration from '../../../../../../components/EmptyState/SpotIllustration';

const heading = 'No tenants added yet';
const body = 'Keep track of who’s living in your rental, what their lease terms are, and how to reach them.';

type Props = {
  onAddTenantClick?: () => void;
};

const EmptyTenantsCard = ({ onAddTenantClick }: Props) => {
  return (
    <EmptyState
      data-testid="EmptyTenantsCard"
      icon={<SpotIllustration src={TEAM_ILLUSTRATION_URL} />}
      heading={heading}
      body={body}
      useCard={false}
      primaryAction={onAddTenantClick ? { label: 'Add tenant', onClick: onAddTenantClick } : undefined}
    />
  );
};

export default EmptyTenantsCard;
